

// WGS84 UTM32
import { fromLonLat } from 'ol/proj.js';
import { Projection } from 'ol/proj.js';
import {get as getProjection, getTransform} from 'ol/proj.js';
import proj4 from 'proj4';
import {register} from 'ol/proj/proj4.js';

// Proj4js.defs["EPSG:32632"] = "+proj=utm +zone=32 +ellps=WGS84 +datum=WGS84 +units=m +no_defs";

// Assuming you have the necessary parameters for EPSG:32632



const proj4def = "+proj=utm +zone=32 +ellps=WGS84 +datum=WGS84 +units=m +no_defs";
// proj4.defs("EPSG:32632","+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs +type=crs");
proj4.defs("EPSG:32632", proj4def);
register(proj4);
const epsg32632Projection = getProjection("EPSG:32632");
// const epsg32632Projection = new Projection({
//     code: 'EPSG:32632',
//     extent: [166021.4431, 0.0, 833978.5569, 9329005.1825],
//     units: 'm',
//     axisOrientation: 'neu',
//     global: false
// });



const step250 = 250 // m

//BOTTOM,LEFT
const WGS84_UTM32_x1 = 348920
const WGS84_UTM32_y1 = 5029050
//TOP,RIGHT
const WGS84_UTM32_x2 = 389170
const WGS84_UTM32_y2 = 5060300 // 5060301  (corretto a 5060300???)



const isValidUTMPNGP250 = function(squareID){

    if (squareID>0)
    if (squareID<5023)  return true

    if (squareID>5022)
    if (squareID<9983)  return true

    if (squareID>9982)
    if (squareID<15086) return true

    if (squareID>15085)
    if (squareID<20126) return true

    return false

}


// const prj3857 = new Projection('EPSG:3857')


// proj4.defs("EPSG:32632","+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs +type=crs");

// proj4.defs("EPSG:32632","+proj=utm +zone=32 +datum=WGS84 +units=m +no_defs +type=crs");

const EPSG4326_to_UTMPNGP250 = (coords) => {
        // const lonlat = [lon, lat]
        // debugger
        // return {squareID:"not yet"}

        if (!coords) {coords = [0,0] }
        if (typeof coords == "object") {
            coords = [0,0]
        }

        const epsg32632 = fromLonLat(coords, epsg32632Projection)
        return WGS84UTM32_to_UTMPNGP250(epsg32632[0], epsg32632[1])
}

const WGS84UTM32_to_UTMPNGP250 = function(xpoint, ypoint){


    // const WGS84_UTM32_width = WGS84_UTM32_x2-WGS84_UTM32_x1 //= 31250   --> /250 = 125      #number of horizontal squares
    // const WGS84_UTM32_height = WGS84_UTM32_y2-WGS84_UTM32_y1 //= 40250   --> /250 = 161        #number of vertical squares

    //console.log("WGS84_UTM32_width: "+WGS84_UTM32_width)
    //console.log("WGS84_UTM32_height: "+WGS84_UTM32_height)


    // const hsquares = WGS84_UTM32_width / step250        // 125
    // const vsquares = WGS84_UTM32_height / step250        // 161

    //console.log("hsquares: "+hsquares)
    //console.log("vsquares: "+vsquares)


    const x_rectangle = Math.floor ( (xpoint - WGS84_UTM32_x1)  / step250  ) // correzione fish
    const y_rectangle = Math.floor ( (ypoint - WGS84_UTM32_y1)  / step250  ) // correzione fish

    //console.log("coord x_rectangle: " + x_rectangle)
    //console.log("coord y_rectangle: " + y_rectangle)



    let squareID = "-1"  // error, out of bounds

    //console.log(""+xpoint+","+ypoint)
    if (xpoint < WGS84_UTM32_x1 || xpoint > WGS84_UTM32_x2 || ypoint > WGS84_UTM32_y2 || ypoint < WGS84_UTM32_y1) {
        //console.log("Out of bounds!")

        return {
            "squareID": -1,
            "center": {
                "x":0,
                "y":0
            }
        }
    }



    //console.log("o meno??")


    // first quadrant (top-left)

    if (x_rectangle < 81) // OK
        if (y_rectangle > 62)
            squareID = x_rectangle + 1 + (124 - y_rectangle) * 81   // 9983 first (on first col)

    // second quadrant (bottom-left)

    if (x_rectangle < 81) // OK
            if (y_rectangle <= 62)
            squareID = x_rectangle + 1 + 4960 + (124 - y_rectangle) * 81

    // third quadrant (top-right)

    if (x_rectangle >= 81) // OK
        if (y_rectangle > 62)
            squareID = x_rectangle + 4942 + (124 - y_rectangle) * 80   // 9983 first (on first col)


    // fourth quadrant (bottom-right)

    if (x_rectangle >= 81)
        if (y_rectangle <= 62)
            squareID = x_rectangle + 10045 + (124 - y_rectangle) * 80    // pazzi maniaci, qui il passo è 80!!!



    const x_rectangle_center = WGS84_UTM32_x1 + (x_rectangle)*250 + step250/2
    const y_rectangle_center = WGS84_UTM32_y1 + (y_rectangle)*250 + step250/2


    return {
        "squareID": squareID,
        "center": [x_rectangle_center,y_rectangle_center],
        "format": "EPSG:32632"
    }


} // end of WGS84UTM32_to_UTMPNGP250




const UTMPNGP250_to_WGS84UTM32 = function(squareID_input){


    // const WGS84_UTM32_width = WGS84_UTM32_x2-WGS84_UTM32_x1 //= 31250   --> /250 = 125      #number of horizontal squares
    // const WGS84_UTM32_height = WGS84_UTM32_y2-WGS84_UTM32_y1 //= 40250   --> /250 = 161        #number of vertical squares

    //console.log("WGS84_UTM32_width: "+WGS84_UTM32_width)
    //console.log("WGS84_UTM32_height: "+WGS84_UTM32_height)


    // const hsquares = WGS84_UTM32_width / step250        // 125
    // const vsquares = WGS84_UTM32_height / step250        // 161

    //console.log("hsquares: "+hsquares)
    //console.log("vsquares: "+vsquares)



    //console.log("coord x_rectangle: " + x_rectangle)
    //console.log("coord y_rectangle: " + y_rectangle)


    const squareID = parseInt(Math.floor(squareID_input))


    var returningSquare = {
        "squareID": squareID,
        "center": null,
        "format": "EPSG:32632"
    }


/*
//BOTTOM,LEFT
var WGS84_UTM32_x1 = 348920
var WGS84_UTM32_y1 = 5029050
//TOP,RIGHT
var WGS84_UTM32_x2 = 389170
var WGS84_UTM32_y2 = 5060300 // 5060301  (corretto a 5060300???)

*/

    let xxx = false
    let yyy = false

    // TOP LEFT
    if (squareID>0)
    if (squareID<5023)
        {
            // console.log("top-left square")            
            xxx = WGS84_UTM32_x1 + (((squareID-1) % 81)) * step250            + step250/2
            yyy = WGS84_UTM32_y2 - Math.floor((squareID-1) / 81) * step250 - step250/2
        }
    // TOP RIGHT
    if (squareID>5022)
    if (squareID<9983)
        {
            // console.log("top-right square")            
            xxx = WGS84_UTM32_x1 + step250*81 + (((squareID-5023) % 80)) * step250 + step250/2
            yyy = WGS84_UTM32_y2 -(Math.floor((squareID-5023) / 80)) * step250 - step250/2
        }


        // BOTTOM LEFT
    if (squareID>9982)
    if (squareID<15086)
        {
            // console.log("bottom-left square")
            xxx = WGS84_UTM32_x1 + (((squareID-9983) % 81)) * step250            + step250/2
            yyy = WGS84_UTM32_y2 - step250*62 - (Math.floor((squareID-9983) / 81)) * step250 - step250/2
        }


// BOTTOM RIGHT
    if (squareID>15085)
    if (squareID<20126)
        {
            // console.log("bottom-right square")            
            xxx = WGS84_UTM32_x1 + step250*81 + (((squareID-15086) % 80)) * step250            + step250/2
            yyy = WGS84_UTM32_y2 - step250*62 - (Math.floor((squareID-15086) / 80)) * step250 - step250/2
        }



    if (xxx && yyy)

        returningSquare =  {
            "squareID": squareID,
            "center": [xxx,yyy],
            "format": "EPSG:32632"
        }

    return returningSquare

} // end of WGS84UTM32_to_UTMPNGP250




// i pochi quadrati attorno all'attuale 1+8+16)
const q250_geojson = function(coordinates32632){

    // console.log("q250_geojson run")

    const featureGeoJSON = {
        type: "FeatureCollection",
        name: "q250",
        crs: { type: "EPSG", properties: { code: "32632" } },
        features: [],
        properties: {
            selectable: false,
        }
    }

    if (!coordinates32632) return featureGeoJSON

    // console.log("coordinates32632")
    // console.log(coordinates32632)

    const xpoint = coordinates32632[0]
    const ypoint = coordinates32632[1]
    
    // const xpoint = 358404.82
    // const ypoint = 5049846.9

    const squareObjects = []
    const currSquare = WGS84UTM32_to_UTMPNGP250(xpoint,ypoint)

    squareObjects.push( currSquare )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0],            currSquare.center[1]+step250 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0],            currSquare.center[1]-step250 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]+step250,    currSquare.center[1] )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]-step250,    currSquare.center[1] )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]+step250,    currSquare.center[1]+step250 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]-step250,    currSquare.center[1]-step250 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]+step250,    currSquare.center[1]-step250 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]-step250,    currSquare.center[1]+step250 )  )

    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]-step250*2,    currSquare.center[1]+step250*2 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]-step250*1,    currSquare.center[1]+step250*2 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]-step250*0,    currSquare.center[1]+step250*2 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]+step250*1,    currSquare.center[1]+step250*2 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]+step250*2,    currSquare.center[1]+step250*2 )  )

    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]-step250*2,    currSquare.center[1]-step250*2 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]-step250*1,    currSquare.center[1]-step250*2 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]-step250*0,    currSquare.center[1]-step250*2 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]+step250*1,    currSquare.center[1]-step250*2 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]+step250*2,    currSquare.center[1]-step250*2 )  )

    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]+step250*2,    currSquare.center[1]-step250*1 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]+step250*2,    currSquare.center[1]-step250*0 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]+step250*2,    currSquare.center[1]+step250*1 )  )

    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]-step250*2,    currSquare.center[1]-step250*1 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]-step250*2,    currSquare.center[1]-step250*0 )  )
    squareObjects.push(  WGS84UTM32_to_UTMPNGP250( currSquare.center[0]-step250*2,    currSquare.center[1]+step250*1 )  )


    //console.log("squareObjects length: "+squareObjects.length)

    var squareFromSquareObj = function(squareObj){

        var p1 = {"x": 0, "y": 0}
        var p2 = {"x": 0, "y": 0}
        var p3 = {"x": 0, "y": 0}
        var p4 = {"x": 0, "y": 0}

        //console.dir(squareObj)

        if (squareObj.squareID == -1){
            //console.log("squareObj skipped, id=-1")
            return false
        }

        p1.x = squareObj.center[0] + step250/2
        p1.y = squareObj.center[1] + step250/2

        p2.x = squareObj.center[0] + step250/2
        p2.y = squareObj.center[1] - step250/2

        p3.x = squareObj.center[0] - step250/2
        p3.y = squareObj.center[1] - step250/2

        p4.x = squareObj.center[0] - step250/2
        p4.y = squareObj.center[1] + step250/2


        var coordinates =[
         [p1.x, p1.y],
         [p2.x, p2.y],
         [p3.x, p3.y],
         [p4.x, p4.y],
         [p1.x, p1.y]
         ]

        return {
            "label": squareObj.squareID+"",
            "coordinates": coordinates
        }

    }




    for (const i in squareObjects){

        let s = squareObjects[i]
        const res = squareFromSquareObj(s)
        if (res == false) continue

        const square = {    type: "Feature",
                    geometry: {
                       type: "Polygon",
                       coordinates: [res.coordinates]
                    },
                    properties: {
                        title: res.label
                    }
                }

        featureGeoJSON.features.push(square)


        // const squareLabel = { "type": "Feature",
        //             "geometry": {
        //                "type": "Point",
        //                "coordinates": [parseInt(s.center[0]), parseInt(s.center[1])]
        //             },
        //             "properties": {
        //                "title": res.label
        //             }
        //         }
        // featureGeoJSON.features.push(squareLabel)

    }

    // console.dir(featureGeoJSON)
    // console.log("features ## "+featureGeoJSON.features.length)
    // console.log(  JSON.stringify(featureGeoJSON)  )

    return featureGeoJSON


} // end of q250_geojson





export {WGS84UTM32_to_UTMPNGP250, EPSG4326_to_UTMPNGP250, UTMPNGP250_to_WGS84UTM32, q250_geojson, isValidUTMPNGP250}


